// ** Reducers Imports
import layout from './layout';
import navbar from './navbar';

export const reducers = { layout, navbar };

export default reducers;
